// extracted by mini-css-extract-plugin
module.exports = {"root":"ClientCreditCards_root__1QA20","cards":"ClientCreditCards_cards__10odI","empty":"ClientCreditCards_empty__SDBJB"};